import { IOrderItemDto, IOrderItemChoiceDto, ISessionItem } from "@crunchit/types";

function mapOrderItemChoiceToOrderListChoice(orderItemChoice: IOrderItemChoiceDto) {
  return {
    ...orderItemChoice,
    price: orderItemChoice.unitPrice,
  };
}

/**
 * Mapping order items to session items
 * @param orderItems
 */
export function mappedOrderProducts(orderItems: IOrderItemDto[]) {
  return orderItems.map<ISessionItem>((orderProduct) => {
    const totalPrice = orderProduct.total * orderProduct.amount;
    const choices = orderProduct.choices.map(mapOrderItemChoiceToOrderListChoice);

    return {
      ...orderProduct,
      totalPrice,
      choices,
    };
  });
}
